import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { VueDialogPlugin, TextSlicePlugin } from "@/shared";

// Icons
import "@assets/tirscript/style.css";
import "@mdi/font/css/materialdesignicons.css";

// Fonts
import "@assets/fonts/Montserrat/style.css";
import "@assets/fonts/gilroy/style.css";
import "@assets/styles/proxima-nova/style.css";
import "@assets/styles/style.css";

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

import notification from "./notifications";
import { VueReCaptcha } from 'vue-recaptcha-v3';


const pinia = createPinia();

const vuetify = createVuetify({
  components,
  directives,
});

const appsettings = await fetch("/appsettings.json");
const file = await appsettings.json();

const app = createApp(App);
app.use(router);
app.use(pinia);
app.use(vuetify);
app.use(VueReCaptcha,{
  siteKey:file.ReCaptchaSiteKey,
  loaderOptions:{
    useRecaptchaNet: true
  }
});
VueDialogPlugin.install(app);
TextSlicePlugin.install(app);
notification.install(app);

app.mount("#app");
